export const books = [
  {
    title: "The Inner Battlefield",
    subtitle: "What the Bhagavad Gita Actually Teaches",
    asin: "B0GZBHNHCH",
    theme: "Gita",
    tone: "Dharma, action, and inner conflict",
    brief:
      "A direct reading of the Bhagavad Gita as an inner battlefield: fear, duty, surrender, clarity, and the courage to act without losing the self.",
    amazonUrl: "https://www.amazon.in/Inner-Battlefield-Bhagavad-Actually-Teaches-ebook/dp/B0GZBHNHCH",
  },
  {
    title: "SANDHIKALAM",
    subtitle: "The Hidden Door to Sathya Yuga",
    asin: "B0GZBZ1RWJ",
    theme: "Yuga",
    tone: "Thresholds, transition, and time",
    brief:
      "A contemplative work on sandhikalam: the threshold between ages, the hidden door of transition, and the inner preparation needed for a more truthful age.",
    amazonUrl: "https://www.amazon.in/SANDHIKALAM-Hidden-Door-Sathya-Yuga-ebook/dp/B0GZBZ1RWJ",
  },
  {
    title: "The Long Walk Home",
    subtitle: "What the Ramayana Means for Everything",
    asin: "B0GZBK7YP9",
    theme: "Ramayana",
    tone: "Exile, devotion, return, and meaning",
    brief:
      "A reflective journey through the Ramayana as a map of exile and return: love, duty, loss, devotion, and the long walk back to what is true.",
    amazonUrl: "https://www.amazon.in/Long-Walk-Home-Ramayana-Everything-ebook/dp/B0GZBK7YP9",
  },
  {
    title: "Untrain Your Mind",
    subtitle: "Freedom from Overthinking",
    asin: "B0GQCPZ6CM",
    theme: "Mind",
    tone: "Clarity, attention, and inner freedom",
    brief:
      "A practical guide for loosening the habits of overthinking and returning to simple attention, quieter awareness, and a freer relationship with the mind.",
    amazonUrl: "https://www.amazon.in/Untrain-Your-Mind-Freedom-Overthinking-ebook/dp/B0GQCPZ6CM",
  },
];
